import {CButton, CCol, CFormSelect, CRow} from "@coreui/react-pro";
import TransferIcon from "../../assets/icons/transfer.svg";
import ToggleIcon from "../../assets/icons/toggle.svg";
import VerticalDots from "../../assets/icons/vertical-dots.svg";
import {BiLeftArrow, BiRightArrow} from "react-icons/bi";
import React from "react";

const KPIDashboard = ({data}) => {
    return <div>
        <CRow className="mb-3 bg-white p-3">
            <div className="d-flex flex-row justify-content-between align-items-center">
                <div>
                    <h5>Complete List of Key Performance Indicator</h5>
                    <p className="small-text-gray">5 KPIs</p>
                </div>
                <div>
                    <a href="/admin/add-new-kpi">
                        <button className="btn btn-primary px-4 py-2 text-white">+ ADD NEW KPI</button>
                    </a>
                </div>
                <div>
                    <a href="/admin/create-cohort">
                        <button className="btn btn-primary px-4 py-2 text-white">+ CREATE COHORT</button>
                    </a>
                </div>
            </div>
        </CRow>
        <CRow>
            <CCol md={12}>
                <table className="table border-0" id="reports-table">
                    <thead className="thead-inverse">
                    <tr className="bg-transparent text-primary">
                        <th>Key Performance Indicator</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="py-2 my-1">
                        <td>
                            <div className="d-flex flex-row align-items-center pt-2">
                                <input type="checkbox" className="me-2"/>
                                <h6 className="m-0">Attendance</h6>
                            </div>
                        </td>
                        <td className="">
                            <img src={TransferIcon} alt="Transfer"/>
                            <span className="px-2 text-primary d-inline">Assign</span>
                            <img src={ToggleIcon} alt="Toggle"/>
                            <img src={VerticalDots} alt="Options"/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-row gap-3">
                        <div className="m-2">Show</div>
                        <CFormSelect
                            aria-label="Default select example"
                            options={[
                                {label: '10', value: '10'},
                                {label: '25', value: '25'},
                                {label: '100', value: '100'},
                                {label: '200', value: '200'}
                            ]}
                            // onChange={(e) => setLimit(e.target.value)}
                        />
                        <div className={"m-2"}>Entries</div>
                    </div>
                    <div className="d-flex flex-row justify-content-center align-items-center">
                        <CButton
                            // disabled={page <= 1} onClick={() => setPage(page - 1)}
                            className={`mx-3 text-white py-1 pb-2 px-3`}>
                            <BiLeftArrow/>
                        </CButton>
                        <CButton
                            // onClick={() => setPage(page + 1)}
                            className="mx-3 text-white py-1 pb-2 px-3"
                            // disabled={page >= totalPageCount}
                        >
                            <BiRightArrow/>
                        </CButton>
                    </div>
                </div>
            </CCol>
        </CRow>
    </div>
}

export default KPIDashboard